import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Trailer', 'TrailerKind', 'TrailerType', 'TrailerLane'],
});
export const trailerApi = apiWithTag.injectEndpoints({
  // tagTypes: ['Trailer', 'TrailerKind', 'TrailerType', 'TrailerLane'],
  endpoints: (builder) => ({
    findAllTrailers: builder.query({
      query: () => `trailers/`,
      providesTags: ['Trailer'],
    }),
    findAllTrailersOfBzp: builder.query({
      query: (code) => `trailers/?bzp__code=${code}`,
      providesTags: ['Trailer'],
    }),
    findTrailerByCardId: builder.query({
      query: (cardId) => `trailers/?trailer_card_id=${cardId}`,
      providesTags: ['Trailer'],
    }),
    findTrailerById: builder.query({
      query: (id) => `trailers/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Trailer', id: result.id }] : ['Trailer'];
      },
    }),
    createTrailer: builder.mutation({
      query: (Trailer) => ({
        url: `trailers/`,
        method: 'POST',
        body: Trailer,
      }),
      invalidatesTags: ['Trailer'],
    }),
    updateTrailer: builder.mutation({
      query: (Trailer) => ({
        url: `trailers/${Trailer.id}/`,
        method: 'PATCH',
        body: Trailer,
      }),
      invalidatesTags: ['Trailer'],
    }),
    deleteTrailer: builder.mutation({
      query: (Trailer) => ({
        url: `trailers/${Trailer.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Trailer'],
    }),

    findAllTrailerKinds: builder.query({
      query: () => `trailer_kinds/`,
      providesTags: ['TrailerKind'],
    }),
    findTrailerKindById: builder.query({
      query: (id) => `trailer_kinds/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'TrailerKind', id: result.id }]
          : ['TrailerKind'];
      },
    }),
    createTrailerKind: builder.mutation({
      query: (kind) => ({
        url: `trailer_kinds/`,
        method: 'POST',
        body: kind,
      }),
      invalidatesTags: ['TrailerKind'],
    }),
    updateTrailerKind: builder.mutation({
      query: (kind) => ({
        url: `trailer_kinds/${kind.id}/`,
        method: 'PATCH',
        body: kind,
      }),
      invalidatesTags: ['TrailerKind'],
    }),
    deleteTrailerKind: builder.mutation({
      query: (kind) => ({
        url: `trailer_kinds/${kind.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TrailerKind'],
    }),

    findAllTrailerTypes: builder.query({
      query: () => `trailer_types/`,
      providesTags: ['TrailerType'],
    }),
    findTrailerTypeById: builder.query({
      query: (id) => `trailer_types/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'TrailerType', id: result.id }]
          : ['TrailerType'];
      },
    }),
    createTrailerType: builder.mutation({
      query: (type) => ({
        url: `trailer_types/`,
        method: 'POST',
        body: type,
      }),
      invalidatesTags: ['TrailerType'],
    }),
    updateTrailerType: builder.mutation({
      query: (type) => ({
        url: `trailer_types/${type.id}/`,
        method: 'PATCH',
        body: type,
      }),
      invalidatesTags: ['TrailerType'],
    }),
    deleteTrailerType: builder.mutation({
      query: (type) => ({
        url: `trailer_types/${type.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TrailerType'],
    }),

    findAllTrailerLanes: builder.query({
      query: () => `lanes/`,
      providesTags: ['TrailerLane'],
    }),
    findTrailerLaneById: builder.query({
      query: (id) => `lanes/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'TrailerLane', id: result.id }]
          : ['TrailerType'];
      },
    }),
    findTrailerLaneByUser: builder.query({
      query: () => `user_trailer_lanes/`,
      providesTags: ['TrailerLane'],
    }),
    findTrailerLaneByCode: builder.query({
      query: (code) => `trailer_lanes_by_code/?location_code=${code}`,
      providesTags: ['TrailerLane'],
    }),

    createTrailerLane: builder.mutation({
      query: (type) => ({
        url: `lanes/`,
        method: 'POST',
        body: type,
      }),
      invalidatesTags: ['TrailerLane'],
    }),
    updateTrailerLane: builder.mutation({
      query: (type) => ({
        url: `lanes/${type.id}/`,
        method: 'PATCH',
        body: type,
      }),
      invalidatesTags: ['TrailerLane'],
    }),
    updateTrailerLaneReceiveJobs: builder.mutation({
      query: (payload) => {
        let payload_lane = {
          trailer_lane: payload.trailer_lane,
        };
        return {
          url: `receive_jobs/${payload.id}/`,
          method: 'PATCH',
          body: payload_lane,
        };
      },
      invalidatesTags: ['TrailerLane'],
    }),
    deleteTrailerLane: builder.mutation({
      query: (type) => ({
        url: `lanes/${type.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TrailerLane'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllTrailersQuery,
  useFindAllTrailersOfBzpQuery,
  useFindTrailerByCardIdQuery,
  useFindTrailerByIdQuery,
  useCreateTrailerMutation,
  useUpdateTrailerMutation,
  useDeleteTrailerMutation,
  // Trailer Kind
  useFindAllTrailerKindsQuery,
  useFindTrailerKindByIdQuery,
  useCreateTrailerKindMutation,
  useUpdateTrailerKindMutation,
  useDeleteTrailerKindMutation,
  // Trailer Type
  useFindAllTrailerTypesQuery,
  useFindTrailerTypeByIdQuery,
  useCreateTrailerTypeMutation,
  useUpdateTrailerTypeMutation,
  useDeleteTrailerTypeMutation,
  // Trailer Lane
  useFindAllTrailerLanesQuery,
  useFindTrailerLaneByIdQuery,
  useFindTrailerLaneByUserQuery,
  useCreateTrailerLaneMutation,
  useUpdateTrailerLaneMutation,
  useUpdateTrailerLaneReceiveJobsMutation,
  useDeleteTrailerLaneMutation,
  useFindTrailerLaneByCodeQuery
} = trailerApi;
